// Table of contents extracted from each volume's PDF (page 3).
export const TOC = {
 "linkedin": [
  [
   "01",
   "Account & campaign structure",
   "The three-tier hierarchy and how to name everything.",
   "Foundation"
  ],
  [
   "02",
   "Campaign objectives",
   "Awareness, consideration, conversion — and when each is a trap.",
   "Foundation"
  ],
  [
   "03",
   "Ad formats",
   "Every placement LinkedIn sells, with specs and cost ranges.",
   "Foundation"
  ],
  [
   "04",
   "Targeting",
   "Professional attributes, company filters, ICP combinations.",
   "Reach"
  ],
  [
   "05",
   "Matched audiences",
   "First-party data activation — where B2B actually wins.",
   "Reach"
  ],
  [
   "06",
   "The insight tag",
   "Pixel installation, website demographics, conversion setup.",
   "Measurement"
  ],
  [
   "07",
   "Bidding & budget",
   "Bid types, minimums, benchmarks by audience class.",
   "Measurement"
  ],
  [
   "08",
   "Attribution",
   "Native models, UTM discipline, CRM-connected revenue.",
   "Measurement"
  ],
  [
   "09",
   "Platform integrations",
   "CRM, MAP, ABM, analytics, CAPI, and middleware.",
   "Measurement"
  ],
  [
   "10",
   "Lead Gen forms",
   "Fields, benchmarks, and LGF vs. landing page strategy.",
   "Execution"
  ],
  [
   "11",
   "Page & organic",
   "Why paid and organic should not be run in silos.",
   "Execution"
  ],
  [
   "12",
   "Testing & optimization",
   "What to test first, significance rules, rotation cadence.",
   "Execution"
  ],
  [
   "13",
   "ABM playbook",
   "Tiers, persona layering, content sequencing.",
   "Execution"
  ],
  [
   "14",
   "Reporting & KPIs",
   "Funnel-stage KPIs, cadence, benchmark targets.",
   "Discipline"
  ],
  [
   "15",
   "Compliance & governance",
   "GDPR, CAN-SPAM, Insight Tag, account hygiene.",
   "Discipline"
  ],
  [
   "16",
   "Quick reference",
   "Launch checklist, common mistakes, vocabulary.",
   "Discipline"
  ]
 ],
 "google": [
  [
   "01",
   "Account & campaign structure",
   "The four-tier hierarchy and how to name everything.",
   "Foundation"
  ],
  [
   "02",
   "Campaign types & goals",
   "Search, PMax, Demand Gen, Video, Display — and when each is a trap.",
   "Foundation"
  ],
  [
   "03",
   "Ad formats & assets",
   "RSAs, assets, display and video specs, with cost ranges.",
   "Foundation"
  ],
  [
   "04",
   "Keywords & match types",
   "Intent taxonomy, match types, negatives, and search term discipline.",
   "Reach"
  ],
  [
   "05",
   "Audiences & Customer Match",
   "First-party data activation — observation, targeting, and lookalikes.",
   "Reach"
  ],
  [
   "06",
   "The Google tag",
   "Tag installation, conversion actions, enhanced conversions, consent mode.",
   "Measurement"
  ],
  [
   "07",
   "Bidding & budget",
   "Smart Bidding strategies, budgets, benchmarks by intent class.",
   "Measurement"
  ],
  [
   "08",
   "Attribution",
   "Data-driven model, GA4, gclid, offline conversion import, CRM revenue.",
   "Measurement"
  ],
  [
   "09",
   "Platform integrations",
   "GA4, CRM, MAP, ABM, analytics, middleware, and the API.",
   "Measurement"
  ],
  [
   "10",
   "Lead forms & landing pages",
   "Lead form assets, landing page quality, and when to use each.",
   "Execution"
  ],
  [
   "11",
   "Performance Max",
   "Asset groups, signals, controls, and how to keep it honest.",
   "Execution"
  ],
  [
   "12",
   "Testing & optimization",
   "Experiments, significance rules, and the weekly cadence.",
   "Execution"
  ],
  [
   "13",
   "Account-based search",
   "Customer Match tiers, persona proxies, and the competitor play.",
   "Execution"
  ],
  [
   "14",
   "Reporting & KPIs",
   "Funnel-stage KPIs, cadence, benchmark targets.",
   "Discipline"
  ],
  [
   "15",
   "Compliance & governance",
   "Consent Mode, policy, trademarks, account hygiene.",
   "Discipline"
  ],
  [
   "16",
   "Quick reference",
   "Launch checklist, common mistakes, vocabulary.",
   "Discipline"
  ]
 ],
 "meta": [
  [
   "01",
   "Account & campaign structure",
   "Business Portfolio, ad account, the three-tier campaign hierarchy, and naming.",
   "Foundation"
  ],
  [
   "02",
   "Campaign objectives",
   "The six objectives, performance goals — and when each is a trap.",
   "Foundation"
  ],
  [
   "03",
   "Ad formats & placements",
   "Every format and placement Meta sells, with specs and cost ranges.",
   "Foundation"
  ],
  [
   "04",
   "Targeting",
   "Core audiences, detailed targeting, Advantage+ audience, and B2B proxies.",
   "Reach"
  ],
  [
   "05",
   "Custom & lookalike audiences",
   "First-party data activation — where B2B actually wins on Meta.",
   "Reach"
  ],
  [
   "06",
   "The Pixel & Conversions API",
   "Dataset setup, standard events, CAPI, match quality, and conversion reporting.",
   "Measurement"
  ],
  [
   "07",
   "Bidding & budget",
   "Bid strategies, CBO vs. ABO, the learning phase, benchmarks by audience class.",
   "Measurement"
  ],
  [
   "08",
   "Attribution",
   "Attribution settings, UTM discipline, Conversion Leads, CRM-connected revenue.",
   "Measurement"
  ],
  [
   "09",
   "Platform integrations",
   "CRM, MAP, ABM, analytics, CAPI gateway, and middleware.",
   "Measurement"
  ],
  [
   "10",
   "Instant forms",
   "Fields, form types, benchmarks, and form vs. landing page strategy.",
   "Execution"
  ],
  [
   "11",
   "Page, organic & creators",
   "Boosting, Page health, Partnership Ads — why paid and organic should not be run in silos.",
   "Execution"
  ],
  [
   "12",
   "Testing & optimization",
   "A/B tests, significance rules, creative fatigue, Advantage+ creative, cadence.",
   "Execution"
  ],
  [
   "13",
   "ABM playbook",
   "Customer List tiers, persona proxies, cross-channel sequencing.",
   "Execution"
  ],
  [
   "14",
   "Reporting & KPIs",
   "Funnel-stage KPIs, cadence, benchmark targets.",
   "Discipline"
  ],
  [
   "15",
   "Compliance & governance",
   "GDPR, ATT, special ad categories, data use, account hygiene.",
   "Discipline"
  ],
  [
   "16",
   "Quick reference",
   "Launch checklist, common mistakes, vocabulary.",
   "Discipline"
  ]
 ],
 "bing": [
  [
   "01",
   "Account & campaign structure",
   "Manager accounts, the four-tier hierarchy, the Google import, and naming.",
   "Foundation"
  ],
  [
   "02",
   "Campaign types & goals",
   "Search, Audience, Performance Max, Shopping — and when each is a trap.",
   "Foundation"
  ],
  [
   "03",
   "Ad formats & assets",
   "RSAs, Multimedia Ads, assets, Audience Ads and video, with cost ranges.",
   "Foundation"
  ],
  [
   "04",
   "Keywords & match types",
   "Intent taxonomy, match types, negatives, partner traffic, and search term discipline.",
   "Reach"
  ],
  [
   "05",
   "LinkedIn profile targeting",
   "Company, industry and job function bid-ups — the thing no other search engine can do.",
   "Reach"
  ],
  [
   "06",
   "The UET tag",
   "Universal Event Tracking installation, conversion goals, enhanced conversions, consent.",
   "Measurement"
  ],
  [
   "07",
   "Bidding & budget",
   "Bid strategies, budgets, the Google import mapping, and benchmarks by intent class.",
   "Measurement"
  ],
  [
   "08",
   "Attribution",
   "Conversion windows, msclkid, UTM discipline, offline conversion import, CRM revenue.",
   "Measurement"
  ],
  [
   "09",
   "Platform integrations",
   "Google import, GA4, Clarity, CRM, MAP, ABM, middleware, Editor and the API.",
   "Measurement"
  ],
  [
   "10",
   "Lead forms & landing pages",
   "Lead form extensions, landing page quality, and when to use each.",
   "Execution"
  ],
  [
   "11",
   "The Audience Network",
   "MSN, Outlook, Edge and partners — native reach to professionals at work.",
   "Execution"
  ],
  [
   "12",
   "Testing & optimization",
   "Experiments, significance rules at low volume, and the weekly cadence.",
   "Execution"
  ],
  [
   "13",
   "Account-based search",
   "Company-level bid-ups, persona layering by job function, the competitor play.",
   "Execution"
  ],
  [
   "14",
   "Reporting & KPIs",
   "Funnel-stage KPIs, cadence, cross-platform comparison, benchmark targets.",
   "Discipline"
  ],
  [
   "15",
   "Compliance & governance",
   "Consent, GDPR, policy and trademarks, LinkedIn data use, account hygiene.",
   "Discipline"
  ],
  [
   "16",
   "Quick reference",
   "Launch checklist, common mistakes, vocabulary.",
   "Discipline"
  ]
 ]
};
